export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(ellipse at 70% 50%, oklch(var(--primary-500) / 1) 0%, transparent 60%), radial-gradient(ellipse at 30% 80%, oklch(var(--accent-500) / 1) 0%, transparent 50%)',
        }}
      />

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-fire-fill text-primary-500 text-xs"></i></span>
              <span className="text-xs text-primary-400 font-medium whitespace-nowrap">深夜追剧首选</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-50 leading-tight mb-4">
              夜猫影院<span className="text-primary-500"> · </span>你的深夜观影伴侣
            </h1>

            <p className="text-base md:text-lg text-primary-400/80 font-heading mb-5">
              最新电影在线看，高清不卡顿，每日更新热门推荐
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              夜猫影院是一个专注于深夜观影体验的电影大全免费平台。我们每日精选最新电影在线看资源，覆盖动作、悬疑、科幻、喜剧等全类型高清电影播放，让每一位深夜追剧的影迷都能享受稳定流畅的观影体验。无论你是想找热门电影推荐，还是重温经典老片，夜猫影院都是你的最佳选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {[
                { icon: 'ri-film-line', label: '覆盖全类型片库' },
                { icon: 'ri-timer-flash-line', label: '每日 20:00 准时更新' },
                { icon: 'ri-shield-check-line', label: '安全稳定不卡顿' },
              ].map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center"><i className={`${stat.icon} text-primary-400 text-sm`}></i></span>
                  <span className="text-xs md:text-sm text-foreground-300 whitespace-nowrap">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); scrollTo('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-950 font-medium text-sm hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-play-circle-fill text-sm"></i></span>
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-secondary-400 text-foreground-200 font-medium text-sm hover:border-primary-400 hover:text-primary-400 transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-trophy-line text-sm"></i></span>
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20projector%20light%20beams%20cutting%20through%20darkness%2C%20red%20velvet%20curtains%20partially%20drawn%2C%20vintage%20film%20reels%20and%20movie%20posters%20on%20dark%20walls%2C%20atmospheric%20noir%20aesthetic%20with%20dramatic%20shadows%2C%20rich%20deep%20colors%2C%20cinematic%20photography%20style%20with%20lens%20flare%2C%20moody%20and%20elegant%20composition&width=960&height=720&seq=hero-cinema-2026&orientation=landscape"
                alt="夜猫影院深夜观影氛围"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-r lg:bg-gradient-to-l from-background-50 via-background-50/60 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}